import React, { useState } from 'react';
import { Row, Col, Tag, Table, Button, Tooltip } from "antd";

import { FormatNumber } from '../../ValueObjects';

export default function TabDetalheItens({ itensNF }) {

    const [percentualDesc, setPercentualDesc] = useState(false);

    function retornarPercentual(perc_desconto, nfi_valordesconto) {
        if (percentualDesc) {
            return (
                <div>
                    <b>{perc_desconto}</b>%
                </div>
            )
        } else {
            return (
                <div>
                    <b>{FormatNumber(nfi_valordesconto, true)}</b>
                </div>
            )
        }
    };

    return (
        <div className="tabela">
            <Table dataSource={itensNF} columns={
                [
                    {
                        title: '',
                        render: ({ pro_codigo, pro_descricao, descricaograde }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                        <Tag color="processing" className="w-75">
                                            <b>{pro_codigo}</b>
                                        </Tag>
                                    </Col>
                                    <Col>
                                        <b>{pro_descricao}</b>
                                    </Col>
                                    {!!descricaograde &&
                                        <Col>
                                            <Tag color="default">
                                                <b>{descricaograde}</b>
                                            </Tag>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Faturado',
                        align: 'center',
                        width: 60,
                        render: ({ pdi_qtdeentregue }) => (
                            <div>
                                <Row justify="center" gutter={[8, 0]}>
                                    <Col>
                                        {!!pdi_qtdeentregue ? <b>{pdi_qtdeentregue}</b> : <b>0</b>}
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Devolvido',
                        align: 'center',
                        width: 60,
                        render: ({ pdi_qtdedevolvido }) => (
                            <div>
                                <Row justify="center" gutter={[8, 0]}>
                                    <Col>
                                        {!!pdi_qtdedevolvido ? <b>{pdi_qtdedevolvido}</b> : <b>0</b>}
                                    </Col>
                                </Row>
                            </div>
                        )
                    },
                    {
                        title: 'Qtde.',
                        width: 50,
                        align: 'center',
                        render: ({ pdi_quantidade }) => (
                            <div>
                                <Row justify="center">
                                    <Col>
                                        <b>{pdi_quantidade}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Tooltip title="Valor Unitário em Reais">
                                Vlr Unt. <small>(R$)</small>
                            </Tooltip>
                        ),
                        align: 'right',
                        width: 80,
                        render: ({ pdi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(pdi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Row justify="space-between" align="middle">
                                <Col>
                                    Desc.:
                                </Col>
                                <Col>
                                    <Tooltip title="Valor Desconto em Reais">
                                        <small> (R$)</small>
                                    </Tooltip>
                                </Col>
                            </Row>
                        ),
                        align: 'right',
                        width: 70,
                        render: ({ pdi_valordesconto }) => (
                            <div>
                                <b>{FormatNumber(pdi_valordesconto, true)}</b>
                            </div>
                        )
                    },
                    {
                        title: (
                            <Tooltip title="Percentual Desconto">
                                <small>(%)</small>
                            </Tooltip>
                        ),
                        align: 'right',
                        width: 40,
                        render: ({ perc_desconto }) => (
                            <div>
                                <b>{FormatNumber(perc_desconto, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Tooltip title="Valor Faturado Reais">
                                Vlr Fat. <small>(R$)</small>
                            </Tooltip>
                        ),
                        align: 'right',
                        width: 75,
                        render: ({ pdi_qtdeentregue, pdi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(pdi_qtdeentregue * pdi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: (
                            <Tooltip title="Valor Total em Reais">
                                Vlr Total. <small>(R$)</small>
                            </Tooltip>
                        ),
                        align: 'right',
                        width: 100,
                        render: ({ pdi_valortotal }) => (
                            <div>
                                <b>{FormatNumber(pdi_valortotal, true)}</b>
                            </div>
                        ),
                    }
                ]
            }
                summary={(itensNF) => {
                    let totalCol6 = 0;
                    let totalCol7 = 0;

                    // Supondo que os dados têm campos: qtde e valor
                    itensNF.forEach(({ pdi_qtdeentregue, pdi_valorunitario, pdi_valortotal }) => {
                        totalCol6 += pdi_qtdeentregue * pdi_valorunitario;
                        totalCol7 += pdi_valortotal;
                    });

                    return (
                        <Table.Summary fixed>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} />
                                <Table.Summary.Cell index={1} />
                                <Table.Summary.Cell index={2} />
                                <Table.Summary.Cell index={3} />
                                <Table.Summary.Cell index={4} />
                                <Table.Summary.Cell index={5} />
                                <Table.Summary.Cell index={6} />
                                <Table.Summary.Cell index={7} align='right'><b>{FormatNumber(totalCol6, true)}</b></Table.Summary.Cell>
                                <Table.Summary.Cell index={8} align='right'><b>{FormatNumber(totalCol7, true)}</b></Table.Summary.Cell>
                            </Table.Summary.Row>
                        </Table.Summary>
                    );
                }}
            />
        </div>
    );
}